import React, { useState, useEffect, useContext } from "react";
import "./Dashboard.scss";
import Schedule from "./Schedule";
import { DndProvider } from "react-dnd";
import { TouchBackend } from 'react-dnd-touch-backend';
import Loader from "../../components/loader/Loader";
import DragPreview from "../../components/dragPreview/DragPreview";
// RO CONFIRM
import ConfirmationModal from "../../components/confirmationModal/ConfirmationModal";
import dashboardApi from "../../services/dashboardApi";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/AuthContext";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  // RO CONFIRM
  const { isROConfirmationModalVisible, setIsROConfirmationModalVisible, isROReload, setIsROReload, completedTaskId } = useContext(AuthContext);
  const [roCompletionConfirmed, setroCompletionConfirmed] = useState(false);

  useEffect(() => {
      setLoading(false);

      // RO CONFIRM
      setIsROConfirmationModalVisible(false);
      //setIsROCompletionConfirmed(false);
  }, []);

  // RO CONFIRM
  const closeModal = () => {
    setIsROConfirmationModalVisible(false); // Close modal
  };

  // setroCompletionConfirmed = async () => {
  //  // setIsROCompletionConfirmed(true);
  // };
  const handleConfirmComplete = async () => {
debugger
    let formattedData = {repairOrderId:completedTaskId}
    const apiresponse=await dashboardApi.updateRepairOrderStatusToCompleted(formattedData);
    if(apiresponse?.data?.ok){
      toast.success(apiresponse?.data?.message);
      setIsROReload(!isROReload)
     }
    else{
      toast.error(apiresponse?.response?.data?.message);
    }
      //setIsROCompletionConfirmed(true);
      //setIsROCompletionConfirmed(true);
    // setIsModalVisible(false);
      setIsROConfirmationModalVisible(false); 
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="dashboard-area">
           <DndProvider backend={TouchBackend} options={{enableMouseEvents:true}}>
            <Schedule />
            <DragPreview/>
            {/* <ToastContainer autoClose={1500} /> */}
          </DndProvider>

          <ConfirmationModal
            show={isROConfirmationModalVisible}
            title="Change Status"
            message="Are you sure you want to change the status of this repair order to Complete?"
            onConfirm={handleConfirmComplete}
            onCancel={closeModal}
            confirmText="Yes, Change"
            cancelText="No, Cancel"
          />

        </div>
      )}
    </>
  );
};

export default Dashboard;
